import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
// @ts-ignore
import { MdApp, MdButton, MdContent, MdDrawer, MdField, MdIcon, MdList, MdToolbar } from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";
import VueI18n from "vue-i18n";
import SongData from "@/assets/songs.json";
Vue.config.productionTip = false;
// Vue.use(VueRouter)
Vue.use(VueI18n);
Vue.use(MdApp);
Vue.use(MdToolbar);
Vue.use(MdDrawer);
Vue.use(MdContent);
Vue.use(MdList);
Vue.use(MdButton);
Vue.use(MdIcon);
Vue.use(MdField);
export var songs = SongData.songs.sort(function (left, right) { return left.name.localeCompare(right.name); });
var uiStrings = {
    en: {
        app_name: "Song Barrel",
        missing_song_title: "Song",
        hint_search: "Search..."
    },
    de: {
        app_name: "Liederfass",
        missing_song_title: "Lied",
        hint_search: "Suchen..."
    }
};
export var i18n = new VueI18n({
    locale: "de",
    messages: uiStrings
});
var app = new Vue({
    i18n: i18n,
    router: router,
    render: function (h) { return h(App); },
    el: "#app"
}); // .$mount("#app")
//# sourceMappingURL=main.js.map